module.exports = __webpack_public_path__ + "img/Egesio-C.244edb1d.png";